import { useEffect, useState } from "react";
import { ISosCdrIndexParams, ISosStats } from "models/Cdr";
import { indexSosStats } from "api/issabel/sos";

const useSosStats = ({ }: ISosCdrIndexParams): {
    data: ISosStats[];
    loading: boolean;
}=> {

    const [data, setData] = useState<ISosStats[]>([]);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        const getSosStats = async () => {
            setLoading(true);
            const { data } = await indexSosStats({});
            setData(data);
            setLoading(false);
        }
        getSosStats();
    }, []);

    return {
        data,
        loading
    };
}

export default useSosStats;